export const categories = [
  { id: 'dianshiju', name: '电视剧', slug: 'dianshiju', icon: 'ri-tv-line', count: 2856 },
  { id: 'dianying', name: '电影', slug: 'dianying', icon: 'ri-film-line', count: 4523 },
  { id: 'zongyi', name: '综艺', slug: 'zongyi', icon: 'ri-emotion-laugh-line', count: 1689 },
  { id: 'dongman', name: '动漫', slug: 'dongman', icon: 'ri-ghost-line', count: 3210 },
  { id: 'jilupian', name: '纪录片', slug: 'jilupian', icon: 'ri-earth-line', count: 876 },
  { id: 'duanju', name: '短剧', slug: 'duanju', icon: 'ri-smartphone-line', count: 5432 },
  { id: 'tiyu', name: '体育', slug: 'tiyu', icon: 'ri-basketball-line', count: 1203 },
  { id: 'yinyue', name: '音乐', slug: 'yinyue', icon: 'ri-music-line', count: 2341 },
];

export const categoriesFull = [
  {
    id: 'dianshiju',
    name: '电视剧',
    slug: 'dianshiju',
    description: '热播国产剧、海外剧集、经典老剧，海量电视剧资源每日更新',
    subCategories: ['国产剧', '港剧', '韩剧', '美剧', '日剧', '泰剧'],
  },
  {
    id: 'dianying',
    name: '电影',
    slug: 'dianying',
    description: '院线大片、经典电影、独立佳作，各类电影一网打尽',
    subCategories: ['动作片', '喜剧片', '爱情片', '科幻片', '恐怖片', '战争片'],
  },
  {
    id: 'zongyi',
    name: '综艺',
    slug: 'zongyi',
    description: '热门综艺节目、真人秀、脱口秀，欢乐不断更新',
    subCategories: ['真人秀', '脱口秀', '音乐综艺', '选秀节目', '访谈节目'],
  },
  {
    id: 'dongman',
    name: '动漫',
    slug: 'dongman',
    description: '日漫、国漫、经典番剧，动漫爱好者聚集地',
    subCategories: ['日漫', '国漫', '剧场版', 'OVA', '新番'],
  },
  {
    id: 'jilupian',
    name: '纪录片',
    slug: 'jilupian',
    description: '自然、历史、科技纪录片，探索世界的精彩',
    subCategories: ['自然', '历史', '科技', '人文', '美食'],
  },
  {
    id: 'duanju',
    name: '短剧',
    slug: 'duanju',
    description: '微短剧、迷你剧、竖屏短剧，碎片时间追剧首选',
    subCategories: ['甜宠', '悬疑', '搞笑', '都市', '古装'],
  },
  {
    id: 'tiyu',
    name: '体育',
    slug: 'tiyu',
    description: 'NBA、足球、电竞、综合体育赛事直播与回放',
    subCategories: ['篮球', '足球', '电竞', '网球', '格斗'],
  },
  {
    id: 'yinyue',
    name: '音乐',
    slug: 'yinyue',
    description: 'MV、演唱会、音乐节目，视听双重享受',
    subCategories: ['华语', '欧美', '日韩', '演唱会', 'Live现场'],
  },
];